import React, { useState } from "react";
import "./AddProduct.css";
import { useNavigate } from "react-router-dom";
import upload_area from "../Assets/upload_area.svg";
import { backend_url } from "../../App";
import { toast, ToastContainer, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { menuItems } from '../../Constants/menuItems';

const AddProduct = () => {
  // const { id } = useParams();
  const [image, setImage] = useState(false);
  const [images, setImages] = useState([]);
  const [productImage, setProductImage] = useState(null);
  const validateForm = () => {
    const {
      name, description, unique_id, category, subcategory, new_price,
      old_price, quantity, scale, material, weight, size, color, quality, status, bestseller,
    } = productDetails;

    return (
      name && description && unique_id &&
      category && subcategory && new_price && old_price &&
      quantity && scale && material && weight && size && color
      && quality && status && bestseller && images.length > 0
    );
  };


  const [productDetails, setProductDetails] = useState({
    name: "",
    description: "",
    unique_id: "",
    category: "Fabric",
    subcategory: "unique costume",
    new_price: "",
    old_price: "",
    bestseller: "No",
    status: "In-Stock",
    quantity: "",
    scale: "Meters",
    material: "",
    weight: "",
    size: "",
    color: "",
    quality: "",
    disclaimer: "",
    washcare: "",
    note: "",
    images: [],
  });

  const initialProductDetails = {
    name: "",
    description: "",
    unique_id: "",
    category: "",
    subcategory: "unique costume",
    new_price: "",
    old_price: "",
    bestseller: "No",
    status: "",
    quantity: "",
    scale: "Meters",
    material: "",
    weight: "",
    size: "",
    color: "",
    quality: "",
    disclaimer: "",
    washcare: "",
    note: "",
    images: [],
  };


  // const AddProduct = async () => {
  //   if (images.length === 0) {
  //     toast.error("Please upload product images", {
  //       autoClose: 2000,
  //       transition: Slide,
  //     });
  //     return;
  //   }

  //   if (!validateForm()) {
  //     toast.error("Please fill all required fields", {
  //       autoClose: 2000,
  //       transition: Slide,
  //     });
  //     return;
  //   }

  //   let uploadedImages = [];

  //   for (let i = 0; i < images.length; i++) {
  //     let formData = new FormData();
  //     formData.append("product", images[i]);

  //     const res = await fetch(`${backend_url}/upload`, {
  //       method: "POST",
  //       headers: {
  //         Accept: "application/json",
  //       },
  //       body: formData,
  //     });

  //     const data = await res.json();

  //     if (data.success) {
  //       uploadedImages.push(data.image_url);
  //     } else {
  //       alert("Failed to upload image");
  //       return;
  //     }
  //   }

  //   // Update product details with uploaded images
  //   const product = {
  //     ...productDetails,
  //     images: uploadedImages,
  //   };

  //   // Send product data to backend
  //   const res = await fetch(`${backend_url}/addproduct`, {
  //     method: "POST",
  //     headers: {
  //       Accept: "application/json",
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify(product),
  //   });

  //   const response = await res.json();

  //   if (response.success) {
  //     toast.success("Product added successfully", {
  //       autoClose: 2000,
  //       transition: Slide,
  //       onClose: () => navigate("/listproduct"), // ✅ Redirect after toast closes
  //     });

  //     setProductDetails(initialProductDetails);
  //     setImages([]);
  //   } else if (!validateForm()) {
  //     toast.error("Please fill all required fields"); {
  //     }
  //   }
  //   else {
  //     toast.error("Failed to add product");
  //   }
  // };

  // Handle multiple file uploads


  const AddProduct = async () => {
    if (images.length === 0) {
      toast.error("Please upload product images", {
        autoClose: 2000,
        transition: Slide,
      });
      return;
    }

    if (!validateForm()) {
      toast.error("Please fill all required fields", {
        autoClose: 2000,
        transition: Slide,
      });
      return;
    }

    const formData = new FormData();

    // Append product details
    for (const key in productDetails) {
      formData.append(key, productDetails[key]);
    }

    // Append images (field name must be 'images' to match backend)
    images.forEach((image) => {
      formData.append("images", image);
    });

    try {
      const res = await fetch(`${backend_url}/addproduct`, {
        method: "POST",
        body: formData,
      });

      const response = await res.json();

      if (response.success) {
        toast.success("Product added successfully", {
          autoClose: 2000,
          transition: Slide,
          onClose: () => navigate("/listproduct"),
        });

        setProductDetails(initialProductDetails);
        setImages([]);
      } else {
        toast.error(response.message || "Failed to add product");
      }
    } catch (error) {
      console.error("Add product error:", error);
      toast.error("An error occurred while adding the product");
    }
  };


  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);


    if (images.length + files.length > 4) {
      toast.error("You can upload a maximum of 4 images!");
      return;
    }

    // Check if any file is larger than 2MB
    const oversized = files.find((file) => file.size > 2 * 1024 * 1024);
    if (oversized) {
      toast.error(`Image "${oversized.name}" exceeds 2MB limit!`);
      return;
    }

    setImages((prev) => [...prev, ...files]);
  };

  // Handle input changes
  const changeHandler = (e) => {
    setProductDetails({ ...productDetails, [e.target.name]: e.target.value });
  };

  // Handle image removal
  const removeImage = (index) => {
    setImages(images.filter((_, i) => i !== index));
  };

  const getSubcategories = () => {
    const selectedCategory = menuItems.find(
      (item) => item.value === productDetails.category
    );
    if (!selectedCategory) return [];

    // Flatten the subcategories
    return selectedCategory.dropdown.flatMap((sub) => {
      if (sub.subcategories) {
        // Include parent as non-selectable and add nested subcategories
        return [
          { label: sub.label, value: null, isParent: true },
          ...sub.subcategories.map((nested) => ({
            ...nested,
            isNested: true,
          })),
        ];
      }
      return sub;
    });
  };

  const changeCategoryHandler = (e) => {
    const { name, value } = e.target;

    setProductDetails((prev) => {
      if (name === "category") {
        return { ...prev, category: value, subcategory: "" };
      }

      if (name === "subcategory") {
        return { ...prev, subcategory: value };
      }

      return prev;
    });
  };

  const navigate = useNavigate();

  const handleCancel = () => {
    setProductDetails(initialProductDetails);
    setImages([]);
    navigate(-1);
  };


  return (
    <>
      <div className="addproduct">

        {/* Product Title */}
        <div className="addproduct-itemfield">
          <p className="product-input-title">Product Name</p>
          <input
            type="text"
            name="name"
            value={productDetails.name}
            onChange={changeHandler}
            maxLength={200}
          />
        </div>

        {/* Product Unique ID */}
        <div className="addproduct-price">
          <div className="addproduct-itemfield">
            <p className="product-input-title">Product Unique Id</p>
            <input
              type="text"
              name="unique_id"
              value={productDetails.unique_id}
              onChange={changeHandler}
              required />
          </div>

          {/* Product Quantity */}
          <div className="addproduct-itemfield">
            <p className="product-input-title">Product Quantity</p>
            <input
              type="text"
              name="quantity"
              value={productDetails.quantity}
              onChange={changeHandler}
            />
          </div>
          <div className="addproduct-itemfield">
            <p className="product-input-title">Scalability</p>
            <select
              value={productDetails.scale}
              name="scale"
              className="add-product-selector"
              onChange={changeHandler}
            >
              <option value="Meters">Meters</option>
              <option value="Pcs">Pieces</option>          </select>
          </div>
        </div>

        {/* Price and Offer Price */}
        <div className="addproduct-price">
          <div className="addproduct-itemfield">
            <p className="product-input-title">Price</p>
            <input
              type="number"
              name="old_price"
              value={productDetails.old_price ?? 0}
              onChange={changeHandler}

            />
          </div>
          <div className="addproduct-itemfield">
            <p className="product-input-title">Offer Price(%)</p>
            <input
              type="number"
              name="new_price"
              value={productDetails.new_price ?? 0}
              onChange={changeHandler}
            />
          </div>
        </div>

        {/* Category and Subcategory */}
        {/* <div className="addproduct-price">
        <div className="addproduct-itemfield">
          <p className="product-input-title">Product Category</p>
          <select
            value={productDetails.category}
            name="category"
            className="add-product-selector"
            onChange={changeHandler}
          >
            <option value="women">Women</option>
            <option value="men">Men</option>
            <option value="kid">Kids</option>
          </select>
        </div>
        <div className="addproduct-itemfield">
          <p className="product-input-title">Product Subcategory</p>
          <select
            value={productDetails.subcategory}
            name="subcategory"
            className="add-product-selector"
            onChange={changeHandler}
          >
            <option value="unique costume">Unique Costume</option>
            <option value="sarees">Sarees</option>
            <option value="kids">Kids</option>
          </select>
        </div>
      </div> */}

        <div className="addproduct-price">
          {/* Category */}
          <div className="addproduct-itemfield">
            <p className="product-input-title">Product Category</p>
            <select
              value={productDetails.category}
              name="category"
              className="add-product-selector"
              onChange={changeCategoryHandler}
            >
              <option value="">Select Category</option>
              {menuItems.map((item) => (
                <option key={item.value} value={item.value}>
                  {item.label}
                </option>
              ))}
            </select>
          </div>

          {/* Subcategory */}
          <div className="addproduct-itemfield">
            <p className="product-input-title">Product Subcategory</p>
            <select
              value={productDetails.subcategory}
              name="subcategory"
              className="add-product-selector"
              onChange={changeCategoryHandler}
              disabled={!productDetails.category}
            >
              <option value="">Select Subcategory</option>
              {getSubcategories().map((sub) => (
                <option
                  key={sub.value || sub.label}
                  value={sub.value || ""}
                  disabled={sub.isParent}
                  className={
                    sub.isParent
                      ? "option-parent"
                      : sub.isNested
                        ? "option-nested"
                        : "option-child"
                  }
                >
                  {sub.isNested ? `⎯⎯ ${sub.label}` : sub.label}
                </option>
              ))}
            </select>

          </div>
        </div>



        {/* Status and Bestseller */}
        <div className="addproduct-price">
          <div className="addproduct-itemfield">
            <p className="product-input-title">Availability</p>
            <select
              value={productDetails.status}
              name="status"
              className="add-product-selector"
              onChange={changeHandler}
            >
              <option value="In-Stock">In-Stock</option>
              <option value="Out of Stock">Out of Stock</option>
              <option value="Low Stock">Low Stock</option>
            </select>
          </div>
          <div className="addproduct-itemfield">
            <p className="product-input-title">Is Bestseller:</p>
            <select
              value={productDetails.bestseller}
              name="bestseller"
              className="add-product-selector"
              onChange={changeHandler}
            >
               <option value="No">No</option>
              <option value="Yes">Yes</option>
             
            </select>
          </div>
        </div>

        {/* Material & Weight */}
        <div className="addproduct-price">
          <div className="addproduct-itemfield">
            <p className="product-input-title">Material</p>
            <input
              type="text"
              name="material"
              value={productDetails.material}
              onChange={changeHandler}
              maxLength={20}
            />
          </div>
          <div className="addproduct-itemfield">
            <p className="product-input-title">Weight</p>
            <input
              type="text"
              name="weight"
              value={productDetails.weight}
              onChange={changeHandler}
              maxLength={20}
            />
          </div>
          <div className="addproduct-itemfield">
            <p className="product-input-title">Size</p>
            <input
              type="text"
              name="size"
              maxLength={20}
              value={productDetails.size}
              onChange={changeHandler}
            />
          </div>
        </div>

        {/* Size & Quality */}
        <div className="addproduct-price">
          <div className="addproduct-itemfield">
            <p className="product-input-title">Color</p>
            <input
              type="text"
              name="color"
              maxLength={20}
              value={productDetails.color}
              onChange={changeHandler}
            />
          </div>
          <div className="addproduct-itemfield">
            <p className="product-input-title">Quality</p>
            <input
              type="text"
              name="quality"
              value={productDetails.quality}
              onChange={changeHandler}
            />
          </div>
        </div>

        {/* Disclaimer & Washcare */}

        <div className="addproduct-itemfield">
          <p className="product-input-title">Disclaimer</p>
          <input
            type="text"
            name="disclaimer"
            value={productDetails.disclaimer}
            onChange={changeHandler}
            maxLength={200}
          />
          <div className="max-error">
            <p></p>
            {productDetails.disclaimer.length >= 200 && (
              <p className="error-message">Character limit exceeded! Max 200 characters allowed.</p>
            )}
          </div>
        </div>
        <div className="addproduct-itemfield">
          <p className="product-input-title">Washcare</p>
          <input
            type="text"
            name="washcare"
            value={productDetails.washcare}
            onChange={changeHandler}
            maxLength={200}
          />
          <div className="max-error">
            <p></p>
            {productDetails.washcare.length >= 200 && (
              <p className="error-message">Character limit exceeded! Max 200 characters allowed.</p>
            )}
          </div>
        </div>

        <div className="addproduct-itemfield">
          <p className="product-input-title">Note</p>
          <input
            type="text"
            name="note"
            value={productDetails.note}
            maxLength={200}
            onChange={changeHandler}
          />
          <div className="max-error">
            <p></p>
            {productDetails.note.length >= 200 && (
              <p className="error-message">Character limit exceeded! Max 200 characters allowed.</p>
            )}
          </div>
        </div>

        {/* Product Description */}
        <div className="addproduct-itemfield">
          <p className="product-input-title">Product Description</p>
          <textarea
            type="text"
            name="description"
            value={productDetails.description}
            onChange={changeHandler}
            maxLength={500}
          />
          <div className="max-error">
            <p className="char-count">
              Characters Remaining: {productDetails.description.length}/500
            </p>

            {productDetails.description.length >= 500 && (
              <p className="error-message">Character limit exceeded! Max 500 characters allowed.</p>
            )}
          </div>
        </div>

        {/* Multiple Image Upload */}
        <div className="addproduct-itemfield">
          <p className="product-input-title">Product Images<span style={{ color: 'rgb(134 83 225)' }}>: (First image is considered to be the product Thumbnail Image)</span></p>
          <div className="product-image-upload">

            {/* Upload Button */}
            <label htmlFor="file-input">
              <input
                id="file-input"
                type="file"
                multiple
                accept="image/*"
                onChange={handleFileChange}
                hidden
              />
              <img
                className="addproduct-thumbnail-img"
                src={upload_area}
                alt=" 4 Images are allowed"
              />

            </label>

            {/* Display Image Previews */}
            {images.length > 0 && (
              <div className="product-image-preview">
                {images.map((img, index) => (
                  <div key={index} className="image-preview-container">

                    <button
                      className="remove-image-btn"
                      onClick={() => removeImage(index)}
                    >
                      <img
                        src={URL.createObjectURL(img)}
                        alt="Preview"
                        className="addproduct-thumbnail-img"
                      />
                      <span className="remove-text">Remove</span>
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
        <div className="addproduct-actions">
          <button
            className="cancel-btn"
            onClick={handleCancel}
          >
            Cancel
          </button>
          <button
            className={`addproduct-btn`}
            onClick={AddProduct}
          >
            Add
          </button>


        </div>
      </div>

      <ToastContainer />
    </>
  );
};


export default AddProduct;


